import type { IL10nString } from '../api/domain';

export enum DefaultProductCategory {
    PAYMENT = 'PAYMENT',
    SAVING = 'SAVING',
    INVESTMENT = 'INVESTMENT',
    PROVISION = 'PROVISION',
    FINANCING = 'FINANCING',
    CARDS = 'CARDS',
}

export enum DefaultProductCategoryIcon {
    PAYMENT = 'CreditCard',
    SAVING = 'Database',
    INVESTMENT = 'PieChart',
    PROVISION = 'Wallet',
    FINANCING = 'PiggyBank',
    CARDS = 'Bag',
}

export enum CustomProductCategoryIcon {
    BOAT = 'Boat',
    CAR = 'Car',
    EARTH = 'Earth',
    FACTORY = 'Factory',
    GRADUATION_HAT = 'GraduationHat',
    KNIFE = 'Knife',
    LOCK = 'Lock',
    PEN = 'Pen',
    STORE = 'Store',
    TORNADO = 'Troando',
    TROPHY = 'Trophy',
    VAULT = 'Wault',
}

export type ProductCategoryIcon = DefaultProductCategoryIcon | CustomProductCategoryIcon;

export interface IProductCategory {
    categoryId: string;
    icon: ProductCategoryIcon;
    title: IL10nString[];
    priority: number;
}
